
import {
    GET_DEFINITION_ACTION_TYPE
} from '../sagas/getDefinition';

const initialState = {
    initialized: false,
    loading: false,
    reportDefinition: null
};

export function getReportDefinition(state) {
    return state.reportDefinition;
}

export function getReport(state, reportId) {
    return (state.reportDefinition || []).reduce((previous, current) => {
        return (current.id === reportId)
            ? current
            : previous;
    }, null);
}

function definition(state = initialState, action) {
    switch (action.type) {
        case GET_DEFINITION_ACTION_TYPE.LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_DEFINITION_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                reportDefinition: action.reportDefinition,
                loading: false
            };
        case GET_DEFINITION_ACTION_TYPE.FAILED:
            return {
                ...state,
                reportDefinition: null,
                loading: false
            };
        default:
            return state;
    }
}

export default definition;
